export const androidAppLink =
    'https://play.google.com/store/apps/details?id=com.netpulse.mobile.thegymgroup&amp;hl=en_GB&amp;gl=US';

export const appleAppLink =
    'https://apps.apple.com/gb/app/the-gym/id1444707310';

export const tggAppWebPage = 'https://www.thegymgroup.com/the-gym-group-app/';
